export default __webpack_public_path__ + "static/media/loan.7e00c125.webp";